/* eslint-disable no-console */
class Validations {

	constructor (GlobalConfig) {
		const modules = GlobalConfig.modules
		const stages = GlobalConfig.workplanStages
		const userRolesIds = GlobalConfig.userRolesIds
		const activityTypeId = GlobalConfig.activityTypeId
		const projectTypeId = GlobalConfig.typeProject

		function inReview (currentStage) {
			return currentStage === stages.review
		}

		function inApproval (currentStage) {
			return currentStage === stages.approval
		}

		function inExecution (currentStage) {
			return currentStage === stages.execution
		}

		function inReviewExecution (currentStage) {
			return currentStage === stages.reviewExecution
		}

		function inEvaluation (currentStage) {
			return currentStage === stages.evaluation
		}

		function setPermissions (currentStage) {
			let result = [
				userRolesIds.workPlanAdmin,
				userRolesIds.workplanConsultant,
				userRolesIds.unitAdmin,
				userRolesIds.gerencialConsultant,
				userRolesIds.generalConsultant,
				userRolesIds.consultant,
				userRolesIds.support,
				userRolesIds.workplanCommittee,
				userRolesIds.committee,
				userRolesIds.comiteeAdmin,
			]

			if (inReview(currentStage)) {
				return [ userRolesIds.reviewer ].concat(result)
			} else if (inApproval(currentStage)) {
				return [ userRolesIds.approver ].concat(result)
			} else if (inExecution(currentStage)) {
				return [ userRolesIds.teacher ].concat(result)
			} else if (inReviewExecution(currentStage)) {
				return [ userRolesIds.reviewer ].concat(result)
			} else if (inEvaluation(currentStage)) {
				return [ userRolesIds.approver ].concat(result)
			} else {
				return result
			}
		}

		function validUser (currentRoleId, currentStage) {
			const roles = setPermissions(currentStage)
			let idPermitido = false

			for (var i in roles) {
				if (currentRoleId === roles[i]) {
					idPermitido = true
				}
			}

			return idPermitido
		}

		function isSubjectType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.subject
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isActivitiesType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.activities
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isStudentAttentionType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.studentAttention
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isPositionByDelegationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.positionsByDelegation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isCommitteeParticipationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.committeeParticipation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isRolesType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.roles
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isOtherActivitiesType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.otherActivities
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isDoctoralEducationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.doctoralEducation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isTeacherDevelopmentType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.teacherDevelopment
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isCommunityType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.community
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isProjectDesignType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.projectDesign
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isProjectsType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.projects
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isProductsType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.products
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isColaborationSpaceType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.colaborationSpace
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isInvestigationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.investigation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isResultsTransferType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.resultsTransfer
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isInternalProjectsFormulationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.internalProjectsFormulation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isExtensionProjectsType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.extensionProjects
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isVisibilityType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.visibility
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isConsultancyType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.consultancy
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isShortCoursesType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.shortCourses
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isCrossProjectFormulationType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.crossProjectFormulation
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function isCrossExtensionProjectsType (activity) {
			if (!activity) {
				console.log('Not an activity => ', activity)
			} else if (Reflect.has(activity, 'activityTypeId')) {
				return activity.activityTypeId === activityTypeId.crossExtensionProjects
			} else {
				console.log('Not an activity => ', activity)
			}
		}

		function inTeaching (module) {
			return module === modules.teaching
		}

		function inAcademicManagement (module) {
			return module === modules.academicManagement
		}

		function inConsolidation (module) {
			return module === modules.consolidation || module === modules.teaching
		}

		function inInvestigation (module) {
			return module === modules.investigation
		}

		function inExtension (module) {
			return module === modules.extentionAndVisibility
		}

		function isTeacher (currentRoleId) {
			return currentRoleId === userRolesIds.teacher
		}

		function isInternalProject (project) {
			return project.activityTypeId === projectTypeId.internalProject || project.activityTypeId === projectTypeId.internal
		}
		function isCrossProject (project) {
			return project.activityTypeId === projectTypeId.crossProject || project.isProjectCross === projectTypeId.cross
		}

		function hasError (input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function showErrorMessages (input) {
			return input ? (input.$dirty || input.$touched) : false
		}

		function validateForm (form) {
			return form.$invalid
		}

		function isAdminUnit (id) {
			return userRolesIds.unitAdmin == id
		}

		function isGerencialConsultant (id) {
			return userRolesIds.gerencialConsultant == id
		}

		function isCommitteeAdmin (id) {
			return userRolesIds.comiteeAdmin == id   
		}

		function isCommitteeRole (id) {
			return userRolesIds.committee == id   
		}

		function isConsultant (roleId) {
			return userRolesIds.consultant == roleId
		}

		function inConsultant (roleId) {
			return roleId === userRolesIds.workPlanAdmin ||
             roleId === userRolesIds.workplanConsultant
		}

		function inAdminConsultantUnit (roleId) {
			return roleId === userRolesIds.unitAdmin ||
             roleId === userRolesIds.gerencialConsultant
		}

		function isWorkplanCommittee (roleId) {
			return roleId === userRolesIds.workplanCommittee
		}

		return {
			inReview,
			inApproval,
			inExecution,
			inReviewExecution,
			inEvaluation,
			inConsultant,
			inAdminConsultantUnit,
			setPermissions,
			validUser,
			isSubjectType,
			isActivitiesType,
			isStudentAttentionType,
			isRolesType,
			isPositionByDelegationType,
			isCommitteeParticipationType,
			isOtherActivitiesType,
			isDoctoralEducationType,
			isTeacherDevelopmentType,
			isCommunityType,
			isProjectDesignType,
			isProjectsType,
			isProductsType,
			isColaborationSpaceType,
			isResultsTransferType,
			isInvestigationType,
			isInternalProjectsFormulationType,
			isExtensionProjectsType,
			isVisibilityType,
			isConsultancyType,
			isShortCoursesType,
			isCrossProjectFormulationType,
			isCrossExtensionProjectsType,
			inTeaching,
			inAcademicManagement,
			inConsolidation,
			inInvestigation,
			inExtension,
			isTeacher,
			isInternalProject,
			isCrossProject,
			hasError,
			showErrorMessages,
			validateForm,
			isAdminUnit,
			isGerencialConsultant,
			isCommitteeAdmin,
			isCommitteeRole,
			isConsultant,
			isWorkplanCommittee,

		}
	}

}

Validations.$inject = [ 'GlobalConfig' ]

export default angular
	.module('services.Validations', [])
	.service('Validations', Validations).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/lib/validations.js